import { render, staticRenderFns } from "./TeachingReport.vue?vue&type=template&id=0954ef2e&scoped=true"
import script from "./TeachingReport.vue?vue&type=script&lang=js"
export * from "./TeachingReport.vue?vue&type=script&lang=js"
import style0 from "./TeachingReport.vue?vue&type=style&index=0&id=0954ef2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0954ef2e",
  null
  
)

export default component.exports